import React from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes, st } from './ParticipantsTitle.st.css';
import { ParticipantSectionDataHooks } from './dataHooks';

export const ParticipantsTitle = React.forwardRef<HTMLDivElement>((_, ref) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();

  return (
    <div ref={ref} className={st(classes.root, { isMobile })}>
      <Text
        tagName="h2"
        className={classes.title}
        data-hook={ParticipantSectionDataHooks.LIST_TITLE}
      >
        {t('bookings.form.collectParticipant.participants.title')}
      </Text>
    </div>
  );
});

ParticipantsTitle.displayName = 'ParticipantsTitle';
